__turbopack_context__.v({
  "card": "FacetCard-module__z961mq__card",
  "image": "FacetCard-module__z961mq__image",
  "imageRatio": "FacetCard-module__z961mq__imageRatio",
  "link": "FacetCard-module__z961mq__link",
  "title": "FacetCard-module__z961mq__title",
});
